import React from 'react'
import { Row, Col } from 'react-bootstrap'
import vitagePhone from '../../assets/vintage-phone.jpg'
import computerTable from '../../assets/computer-table.jpg'
import headphones from '../../assets/hipster-headphones.jpg'
import { Image } from 'react-bootstrap';


const Opportunities = () => {
  return (
    <Row className=''>
      <Col lg={8} md={12} style={{gridRow: "span 2"}} className='position-relative opp-left p-4'>
        <div style={{background:"rgba(0,0,0,.3)", boxShadow:"0 0 12px white"}} className='h-100 w-100 p-4 border border-light border-2 p-4'>
            <div className='text-light top-0 p-4'>
              <h1 className='display-1'>You second purchase of <span className='text-info'>MYPhone 17 XSPlus Ultra Mega</span> is <span className='text-info'>10% off</span><span className='text-danger fw-bold'>.</span></h1>
            </div>
        </div>
      </Col>
      <Col lg={4} md={12} className="">
        <Row>
          <Col sm={12} className="p-4">
              <div style={{height:"100%", minHeight:"200px"}} className=' display-3 opp-right-top border border-2 border-dark p-4'>Explore Our <span className='text-info'>polaroid</span> cameras<span className='text-danger'>.</span></div>
          </Col>
          <Col sm={12} className="p-4">
            <div style={{height:"100%", boxShadow:"0 0 12px black"}} className='display-4 opp-right-bottom text-light p-4'><span className='text-info'>20%</span> off in standing desks and office chairs<span className='text-danger'>.</span></div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Opportunities